(function () {
  'use strict';

  var rootSelector = '[data-fancy-color-experience]';

  function publish(name, payload) {
    if (window.Shopify && window.Shopify.designMode) return;

    var detail = Object.assign({ component: 'fancy_color_lab_diamonds' }, payload || {});
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, detail);
        return;
      }
    } catch (error) {
      /* A DOM event keeps the interaction observable when analytics is unavailable. */
    }

    window.dispatchEvent(new CustomEvent(name, { detail: detail }));
  }

  function getUtmParameters() {
    var current = new URL(window.location.href);
    var utm = [];
    current.searchParams.forEach(function (value, key) {
      if (key.toLowerCase().indexOf('utm_') === 0) utm.push([key, value]);
    });
    return utm;
  }

  function listenToMediaQuery(query, handler) {
    if (typeof query.addEventListener === 'function') {
      query.addEventListener('change', handler);
    } else if (typeof query.addListener === 'function') {
      query.addListener(handler);
    }
  }

  function RotatingShowcase(card, position) {
    this.card = card;
    this.slides = Array.prototype.slice.call(card.querySelectorAll('[data-fancy-color-showcase-slide]'));
    this.currentIndex = 0;
    this.delay = 5600 + (position * 350);
    this.inViewport = false;
    this.pauseReasons = {};
    this.timer = null;
    this.touchTimer = null;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.mobileViewport = window.matchMedia('(max-width: 559px)');

    if (this.slides.length < 2 || typeof window.IntersectionObserver !== 'function') return;

    this.slides[0].dataset.loaded = 'true';
    card.setAttribute('data-fancy-color-showcase-ready', 'true');

    this.onViewportChange = this.onViewportChange.bind(this);
    this.onVisibilityChange = this.onVisibilityChange.bind(this);
    this.onMotionPreferenceChange = this.onMotionPreferenceChange.bind(this);
    this.onMouseEnter = this.pause.bind(this, 'hover');
    this.onMouseLeave = this.resume.bind(this, 'hover');
    this.onFocusIn = this.pause.bind(this, 'focus');
    this.onFocusOut = this.onFocusOut.bind(this);
    this.onTouchStart = this.onTouchStart.bind(this);

    this.observer = new IntersectionObserver(this.onViewportChange, { threshold: 0.15 });
    this.observer.observe(card);
    card.addEventListener('mouseenter', this.onMouseEnter);
    card.addEventListener('mouseleave', this.onMouseLeave);
    card.addEventListener('focusin', this.onFocusIn);
    card.addEventListener('focusout', this.onFocusOut);
    card.addEventListener('touchstart', this.onTouchStart, { passive: true });
    document.addEventListener('visibilitychange', this.onVisibilityChange);
    listenToMediaQuery(this.reducedMotion, this.onMotionPreferenceChange);
    listenToMediaQuery(this.mobileViewport, this.onMotionPreferenceChange);
  }

  RotatingShowcase.prototype.isStatic = function () {
    return this.reducedMotion.matches || this.mobileViewport.matches;
  };

  RotatingShowcase.prototype.onViewportChange = function (entries) {
    var entry = entries[0];
    this.inViewport = Boolean(entry && entry.isIntersecting && entry.intersectionRatio > 0);
    if (this.inViewport && !this.isStatic()) {
      this.hydrate(this.slides[1]);
      this.schedule();
    } else {
      this.cancel();
    }
  };

  RotatingShowcase.prototype.onVisibilityChange = function () {
    if (document.hidden) {
      this.cancel();
    } else {
      this.schedule();
    }
  };

  RotatingShowcase.prototype.onMotionPreferenceChange = function () {
    if (this.isStatic()) {
      this.cancel();
      this.show(0);
    } else if (this.inViewport) {
      this.hydrate(this.slides[1]);
      this.schedule();
    }
  };

  RotatingShowcase.prototype.onFocusOut = function () {
    var self = this;
    window.setTimeout(function () {
      if (!self.card.contains(document.activeElement)) self.resume('focus');
    }, 0);
  };

  RotatingShowcase.prototype.onTouchStart = function () {
    var self = this;
    this.pause('touch');
    window.clearTimeout(this.touchTimer);
    this.touchTimer = window.setTimeout(function () {
      self.resume('touch');
    }, 12000);
  };

  RotatingShowcase.prototype.pause = function (reason) {
    this.pauseReasons[reason] = true;
    this.cancel();
  };

  RotatingShowcase.prototype.resume = function (reason) {
    delete this.pauseReasons[reason];
    this.schedule();
  };

  RotatingShowcase.prototype.canRotate = function () {
    return this.inViewport && !document.hidden && !this.isStatic() && Object.keys(this.pauseReasons).length === 0;
  };

  RotatingShowcase.prototype.cancel = function () {
    window.clearTimeout(this.timer);
    this.timer = null;
  };

  RotatingShowcase.prototype.schedule = function () {
    var self = this;
    this.cancel();
    if (!this.canRotate()) return;
    this.timer = window.setTimeout(function () { self.advance(); }, this.delay);
  };

  RotatingShowcase.prototype.hydrate = function (slide) {
    if (!slide || slide.dataset.loaded === 'true' || slide.dataset.loading === 'true' || slide.dataset.failed === 'true') return;

    slide.dataset.loading = 'true';
    /*
     * The deferred slides ship with the hidden attribute so the no-JavaScript
     * fallback exposes only the first verified image. Once the card intersects,
     * remove hidden before assigning the source; otherwise browsers may defer a
     * hidden lazy image indefinitely and its load event can never unlock rotation.
     * CSS opacity plus aria-hidden keep this hydrated slide nonvisual and silent
     * until show() promotes it.
     */
    slide.hidden = false;
    slide.setAttribute('aria-hidden', 'true');
    slide.loading = 'eager';
    slide.addEventListener('load', function () {
      slide.dataset.loaded = 'true';
      delete slide.dataset.loading;
    }, { once: true });
    slide.addEventListener('error', function () {
      slide.dataset.failed = 'true';
      delete slide.dataset.loading;
      slide.hidden = true;
    }, { once: true });

    if (slide.dataset.srcset) slide.setAttribute('srcset', slide.dataset.srcset);
    if (slide.dataset.src) slide.setAttribute('src', slide.dataset.src);
  };

  RotatingShowcase.prototype.show = function (index) {
    this.slides.forEach(function (slide, slideIndex) {
      var isActive = slideIndex === index;
      slide.setAttribute('data-active', String(isActive));
      slide.setAttribute('aria-hidden', String(!isActive));
    });
    this.currentIndex = index;
  };

  RotatingShowcase.prototype.advance = function () {
    var nextIndex = (this.currentIndex + 1) % this.slides.length;
    var nextSlide = this.slides[nextIndex];

    if (nextSlide.dataset.failed === 'true') {
      nextIndex = (nextIndex + 1) % this.slides.length;
      nextSlide = this.slides[nextIndex];
    }

    if (nextSlide.dataset.loaded !== 'true') {
      this.hydrate(nextSlide);
      this.schedule();
      return;
    }

    this.show(nextIndex);
    this.hydrate(this.slides[(nextIndex + 1) % this.slides.length]);
    this.schedule();
  };

  function Experience(root) {
    if (!root || root.dataset.fancyColorInitialized === 'true') return;

    root.dataset.fancyColorInitialized = 'true';
    this.root = root;
    this.kind = root.dataset.experienceKind || 'department';
    this.utm = getUtmParameters();
    this.onClick = this.onClick.bind(this);
    this.onSubmit = this.onSubmit.bind(this);

    this.decorateLinks();
    this.initializeShowcases();
    root.addEventListener('click', this.onClick);
    root.addEventListener('submit', this.onSubmit);

    if (this.kind === 'department') {
      publish('fancy_color_department_view', {
        collection_handle: root.dataset.collectionHandle || '',
        mode: root.dataset.mode || 'department',
        product_count: Number(root.dataset.productCount || 0)
      });
    }
  }

  Experience.prototype.initializeShowcases = function () {
    if (this.root.dataset.mode !== 'parent' && this.root.dataset.mode !== 'home') return;
    this.root.querySelectorAll('[data-fancy-color-showcase]').forEach(function (card, index) {
      new RotatingShowcase(card, index);
    });
  };

  Experience.prototype.decorateLinks = function () {
    var self = this;
    if (!this.utm.length) return;

    this.root.querySelectorAll('a[data-fancy-color-link]').forEach(function (link) {
      var rawHref = link.getAttribute('href') || '';
      if (!rawHref || rawHref.charAt(0) === '#' || /^(mailto:|tel:|javascript:)/i.test(rawHref)) return;

      var destination;
      try {
        destination = new URL(rawHref, window.location.href);
      } catch (error) {
        return;
      }
      if (destination.origin !== window.location.origin) return;

      self.utm.forEach(function (parameter) {
        if (!destination.searchParams.has(parameter[0])) {
          destination.searchParams.set(parameter[0], parameter[1]);
        }
      });
      link.setAttribute('href', destination.pathname + destination.search + destination.hash);
    });
  };

  Experience.prototype.onClick = function (event) {
    var target = event.target instanceof Element ? event.target : event.target.parentElement;
    if (!target) return;

    var colorLink = target.closest('[data-fancy-color-color-link]');
    if (colorLink && this.root.contains(colorLink)) {
      publish('fancy_color_select', {
        color: colorLink.dataset.color || '',
        collection_handle: this.root.dataset.collectionHandle || '',
        source: this.kind === 'home' ? 'homepage_color_module' : 'department_color_navigation'
      });
    }

    var shapeButton = target.closest('[data-fancy-color-shape]');
    if (shapeButton && this.root.contains(shapeButton)) {
      var shape = shapeButton.dataset.shape || 'all';
      var visibleCount = this.filterShape(shape);
      publish('fancy_shape_select', {
        shape: shape,
        collection_handle: this.root.dataset.collectionHandle || '',
        visible_product_count: visibleCount
      });
    }

    var productLink = target.closest('[data-fancy-color-product-link]');
    if (productLink && this.root.contains(productLink)) {
      var card = productLink.closest('[data-fancy-color-product-card]');
      if (card) {
        publish('product_card_click', {
          product_id: card.dataset.productId || '',
          product_handle: card.dataset.productHandle || '',
          product_title: card.dataset.productTitle || '',
          color: card.dataset.color || '',
          shape: card.dataset.shape || '',
          position: Number(card.dataset.position || 0),
          collection_handle: this.root.dataset.collectionHandle || ''
        });
      }
    }

    var financingLink = target.closest('[data-fancy-color-financing]');
    if (financingLink && this.root.contains(financingLink)) {
      publish('financing_click', {
        collection_handle: this.root.dataset.collectionHandle || '',
        source: 'fancy_color_department'
      });
    }

    var wholesaleLink = target.closest('[data-fancy-color-wholesale]');
    if (wholesaleLink && this.root.contains(wholesaleLink)) {
      publish('wholesale_inquiry_click', {
        action: 'entry_click',
        collection_handle: this.root.dataset.collectionHandle || '',
        source: 'fancy_color_department_footer'
      });
    }
  };

  Experience.prototype.onSubmit = function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !this.root.contains(form) || form.id !== 'FancyColorWholesaleInquiry') return;

    publish('wholesale_inquiry_click', {
      action: 'form_submit',
      source: 'fancy_color_wholesale_page'
    });
  };

  Experience.prototype.filterShape = function (shape) {
    var cards = Array.prototype.slice.call(this.root.querySelectorAll('[data-fancy-color-product-card]'));
    var visibleCount = 0;

    this.root.querySelectorAll('[data-fancy-color-shape]').forEach(function (button) {
      button.setAttribute('aria-pressed', String((button.dataset.shape || 'all') === shape));
    });

    cards.forEach(function (card) {
      var isVisible = shape === 'all' || card.dataset.shape === shape;
      card.hidden = !isVisible;
      if (isVisible) visibleCount += 1;
    });

    var status = this.root.querySelector('[data-fancy-color-filter-status]');
    if (status) {
      if (shape === 'all') {
        status.textContent = 'Showing all ' + visibleCount + ' engagement rings.';
      } else {
        var shapeLabel = shape.charAt(0).toUpperCase() + shape.slice(1);
        status.textContent = 'Showing ' + visibleCount + ' ' + shapeLabel + ' engagement rings.';
      }
    }

    return visibleCount;
  };

  function initialize(scope) {
    var roots = [];
    if (scope instanceof Element && scope.matches(rootSelector)) roots.push(scope);
    if (scope && scope.querySelectorAll) {
      roots = roots.concat(Array.prototype.slice.call(scope.querySelectorAll(rootSelector)));
    }
    roots.forEach(function (root) { new Experience(root); });
  }

  initialize(document);
  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
})();
